import { useLayoutEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { usePartnerScope } from '../contexts/PartnerScope';
import { useBalloonEventsData } from '../contexts/EventData';

/**
 * Bridges event selection to the partner-scope details pane (mirrors
 * UserScopeEventSync). Closes the pane when an event is selected (before paint),
 * leaves it closed on event-close, and re-syncs the address bar to the scope URL
 * after an event closes (event-open mutates the URL via history.replaceState).
 */
export function PartnerScopeEventSync(): null {
    const { code, closeProfilePane } = usePartnerScope();
    const { selectedEvent, openedEvent } = useBalloonEventsData();
    const location = useLocation();
    const active = Boolean(selectedEvent || openedEvent);
    const wasActiveRef = useRef(false);

    useLayoutEffect(() => {
        if (active && !wasActiveRef.current) {
            closeProfilePane();
        } else if (!active && wasActiveRef.current && code) {
            window.history.replaceState(null, '', location.pathname + location.search);
        }
        wasActiveRef.current = active;
    }, [active, code, closeProfilePane, location.pathname, location.search]);

    return null;
}

export default PartnerScopeEventSync;
